import { Theme } from '@mui/material/styles'

import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'

import { mode } from 'template/material-theme'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({

    // ----------------------------------------------
    // Container

    container: {
      paddingTop: theme.spacing(4),
      '& a': {
        color: 'inherit',
      },
    },
    
    // ----------------------------------------------
    // Liste

    brandsCarousel: {
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(4),

      paddingLeft: theme.spacing(6),
      paddingRight: theme.spacing(6),

      position: 'relative',
      userSelect: 'none',

      '& .swiper-button-prev, & .swiper-button-next': {
        position: 'absolute',
        '&:after': {
          color: theme.palette.primary.light,
        },
      },


    },

    brandSwiper: {
      overflowY: 'hidden',
      touchAction: 'pan-y pinch-zoom',
      overscrollBehaviorX: 'contain',
      scrollbarWidth: 'none',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
      '& .swiper-wrapper': {
        alignItems: 'center',
        willChange: 'transform',
      },
      '& .swiper-slide': {
        backfaceVisibility: 'hidden',
        boxSizing: 'border-box',
        height: 70,
        transform: 'translateZ(0)',
        width: 70,

        '& img': {
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          filter: mode === 'dark' ? 'invert(100%)' : undefined,
        },
      },
    },
    
    // ----------------------------------------------
    // Liste

    brandList: {
      marginTop: theme.spacing(4),

      h4: {
        fontWeight: 'bold',
      },

      '& ul': {
        marginBottom: theme.spacing(6),
        display: 'grid',
        rowGap: theme.spacing(2),
        gridTemplateColumns: 'repeat(1, 1fr)',

        [theme.breakpoints.up('sm')]: { gridTemplateColumns: 'repeat(2, 1fr)', columnGap: theme.spacing(8),},
        [theme.breakpoints.up('md')]: { gridTemplateColumns: 'repeat(3, 1fr)'},
        [theme.breakpoints.up('lg')]: { gridTemplateColumns: 'repeat(4, 1fr)'},

        listStyleType: 'none',
        margin: 0,
        padding: 0,

        '& li': {
          '& a': {
            textDecoration: 'none',
            '&:hover': {
              textDecoration: 'underline',
            }
          },
        },
      }
    },

    // ----------------------------------------------

  })
)

export default useStyles
